module.exports = __webpack_public_path__ + "img/03-pirates.d53ff62c.svg";